import { combineReducers } from 'redux';

import annotations from './annotations';
import axisIntervals from './axisIntervals';
import data from './data';
import documents from './documents';
import econdata from './econdata';
import headings from './headings';
import highcharts from './highcharts';
import legend from './legend';
import plotBands from './plotBands';
import plotLines from './plotLines';
import svgs from './svgs';
import chartCrops from './chartCrops';

const rootReducer = combineReducers({
  axisIntervals,
  annotations,
  legend,
  documents,
  data,
  headings,
  econdata,
  plotBands,
  plotLines,
  highcharts,
  svgs,
  chartCrops,
});

export default rootReducer;
